import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  clearFilters(e) {
    e.preventDefault()

    this.element.querySelectorAll("input[type='checkbox']").forEach(input => {
      input.checked = false
    })

    if (e.target.dataset.submit) {
      const form = document.getElementById(e.target.dataset.form) || e.target.closest("form")
      form.requestSubmit()
    }
  }
}